import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { FAQS } from "@/data/content";

export const FAQ = () => (
  <section id="faq" className="py-24 md:py-32 border-t border-ink/10" data-testid="faq-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">Questions</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
              Everything else.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="multiple" defaultValue={["item-4", "item-7"]} className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-ink/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif text-xl md:text-2xl text-ink hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink/70 text-sm md:text-base leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
